import React, { useState } from "react";
import {
  basicProfileQuestions,
  incomeSpendingOverview,
  goalsPlanning,
  featurePreferences,
  beginnerUserSetting,
  intermediateUserSetting,
  advancedUserSetting,
} from "./constants/Questions";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
import DEATH_API from "../../apis/death.api";
import NewLoader from "../../components/styled-components/loader/NewLoader";
import "./styles/questioner.css";
const steps = [
  { title: "Basic Profile Questions", questions: basicProfileQuestions },
  { title: "Income & Spending Overview", questions: incomeSpendingOverview },
  { title: "Goals & Planning", questions: goalsPlanning },
  { title: "Feature Preferences", questions: featurePreferences },
];

export const Questioner = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(false);

  const history = useHistory();

  // const handleOptionChange = (stepIndex, question, selectedOption) => {
  //   setAnswers((prevAnswers) => {
  //     const updatedAnswers = { ...prevAnswers };
  //     const currentSelections =
  //       (updatedAnswers && updatedAnswers[question]) || [];
  //     if (currentSelections.includes(selectedOption)) {
  //       updatedAnswers[question] = currentSelections.filter(
  //         (opt) => opt !== selectedOption
  //       );
  //     } else {
  //       updatedAnswers[question] = [...currentSelections, selectedOption];
  //     }
  //     return updatedAnswers;
  //   });
  // };

  const handleOptionChange = (
    stepIndex,
    question,
    selectedOption,
    selectType
  ) => {
    setAnswers((prevAnswers) => {
      const updatedAnswers = { ...prevAnswers };

      if (selectType === "multiple") {
        // Multiple selection (checkboxes)
        const currentSelections = updatedAnswers[question] || [];
        if (currentSelections.includes(selectedOption)) {
          updatedAnswers[question] = currentSelections.filter(
            (opt) => opt !== selectedOption
          );
        } else {
          updatedAnswers[question] = [...currentSelections, selectedOption];
        }
      } else {
        // Single selection (radio buttons)
        updatedAnswers[question] = selectedOption;
      }

      return updatedAnswers;
    });
  };

  const handleNext = () => {
    setCurrentStep((prev) => Math.min(prev + 1, steps.length - 1));
  };

  const handlePrevious = () => {
    setCurrentStep((prev) => Math.max(prev - 1, 0));
  };

  const handleSkip = () => {
    handleNext();
  };

  const settings =
    localStorage.getItem("setting") != "undefined" &&
    JSON.parse(localStorage.getItem("setting") || null);
  const defaultUserSetting = {
    dashboard1DragCards: [
      { id: "ChatComponentDashboard" },
      { id: "IncomeAndExpensChart" },
      { id: "UpcomingBillsTable" },
      { id: "DashboardCalendar" },
      { id: "InvestmentWatchlistTable" },
      { id: "budgetExpanse" },
      { id: "goalProgress" },
      { id: "dashboardGoalCharts" },
      { id: "DashboardSavingsGoal" },
      { id: "PortfolioBalancesTable" },
      { id: "LatestNews" },
      { id: "topMonthlyExpanse" },
      { id: "TasksList" },
      { id: "dashboardGoalSection" },
      { id: "StoredDocumentsTable" },
      { id: "TwitterFeeds" },
    ],

    dashboard2DragCards: [
      { id: "UpcomingBillsTable" },
      { id: "dashboardGoalSection" },
      { id: "DashboardCalendar" },
      { id: "InvestmentWatchlistTable" },
      { id: "goalProgress" },
      { id: "PortfolioBalancesTable" },
      { id: "IncomeAndExpensChart" },
      { id: "ChatComponentDashboard" },
      { id: "dashboardGoalCharts" },
      { id: "DashboardSavingsGoal" },
      { id: "LatestNews" },
      { id: "budgetExpanse" },
      { id: "topMonthlyExpanse" },
      { id: "TasksList" },
      { id: "TwitterFeeds" },
      { id: "StoredDocumentsTable" },
    ],
    dashboard3DragCards: [
      { id: "topMonthlyExpanse" },
      { id: "DashboardSavingsGoal" },
      { id: "UpcomingBillsTable" },
      { id: "PortfolioBalancesTable" },
      { id: "dashboardGoalSection" },
      { id: "DashboardCalendar" },
      { id: "IncomeAndExpensChart" },
      { id: "goalProgress" },
      { id: "InvestmentWatchlistTable" },
      { id: "ChatComponentDashboard" },
      { id: "dashboardGoalCharts" },
      { id: "LatestNews" },
      { id: "budgetExpanse" },
      { id: "TasksList" },
      { id: "TwitterFeeds" },
      { id: "StoredDocumentsTable" },
    ],
  };

  const setupDashboardSettingsForNewlyUser = async (newSettings) => {
    try {
      setLoading(true);
      let payload = {
        // ...newSettings,
        dashboard1DragCards: newSettings.dashboard1DragCards,
        dashboard2DragCards: [], // Empty array remove if you want setting for all thrre dashboards
        dashboard3DragCards: [], // Empty array remove if you want setting for all thrre dashboards
      };
      if (settings && settings !== null && settings !== undefined) {
        payload = {
          dashboard2DragCards: [], // Empty array remove if you want setting for all thrre dashboards
          dashboard3DragCards: [],
          ...settings,
          dashboard1DragCards: newSettings.dashboard1DragCards,
        };
      }
      console.log("paylooood", payload);
      const response = await DEATH_API.updateUserAssetSetting(payload);
      if(response && response.status===200){
        await getUserRole();
      }
    } catch (error) {
      console.error("Error updating user settings:", error);
    } finally {
      setLoading(false);
    }
  };

  const calculateTotalPoints = () => {
    let totalPoints = 0;

    steps.forEach((step) => {
      step.questions.forEach((q) => {
        const selectedAnswer = answers && answers[q.question]; // Ensure `answers` is defined

        if (Array.isArray(selectedAnswer)) {
          // Handle multiple selections
          selectedAnswer.forEach((answer) => {
            const selectedOption = q.options.find(
              (opt) => opt.value === answer
            );
            if (selectedOption && selectedOption.points) {
              totalPoints += Number(selectedOption.points) || 0; // Ensure it's a valid number
            }
          });
        } else if (selectedAnswer) {
          // Handle single selection
          const selectedOption = q.options.find(
            (opt) => opt.value === selectedAnswer
          );
          if (selectedOption && selectedOption.points) {
            totalPoints += Number(selectedOption.points) || 0;
          }
        }
      });
    });

    console.log("Calculated Total Points:", totalPoints); // Debugging
    return totalPoints;
  };

  const getUserSettings = (totalPoints) => {
    if (totalPoints >= 0 && totalPoints <= 10) return beginnerUserSetting;
    if (totalPoints >= 11 && totalPoints <= 22) return intermediateUserSetting;
    return advancedUserSetting; // Only if totalPoints > 22
  };
  const getAnswersBasedSetting = () => {
    const selectedDashboardSettings = new Set();

    steps.forEach((step) => {
      step.questions.forEach((q) => {
        const selectedAnswer = answers && answers[q.question];

        if (Array.isArray(selectedAnswer)) {
          // Multiple selections
          selectedAnswer.forEach((answer) => {
            const selectedOption = q.options.find(
              (opt) => opt.value === answer
            );
            if (selectedOption && selectedOption.dashboardSettings) {
              selectedOption.dashboardSettings.forEach((setting) =>
                selectedDashboardSettings.add(setting.id)
              );
            }
          });
        } else if (selectedAnswer) {
          // Single selection
          const selectedOption = q.options.find(
            (opt) => opt.value === selectedAnswer
          );
          if (selectedOption && selectedOption.dashboardSettings) {
            selectedOption.dashboardSettings.forEach((setting) =>
              selectedDashboardSettings.add(setting.id)
            );
          }
        }
      });
    });

    // Convert Set to an array
    // const uniqueDashboardSettings = Array.from(selectedDashboardSettings);
    const uniqueDashboardSettings = Array.from(selectedDashboardSettings).map(
      (id) => ({ id })
    );
    console.log("Unique Dashboard Settings:", uniqueDashboardSettings);
    return uniqueDashboardSettings;
  };

  const handleSave = async () => {
    const totalPoints = calculateTotalPoints();
    let userSettings = getUserSettings(totalPoints);
    const asnswerSetting = getAnswersBasedSetting();

    // Add missing items to each dashboard array (ensuring uniqueness)
    Object.keys(userSettings).forEach((dashboardKey) => {
      const existingIds = new Set(
        userSettings[dashboardKey].map((item) => item.id)
      );

      asnswerSetting.forEach(({ id }) => {
        if (!existingIds.has(id)) {
          userSettings[dashboardKey].push({ id });
        }
      });
    });
    console.log("Total Points:", totalPoints, userSettings, asnswerSetting);

    console.log("Final Answers:", JSON.stringify(answers, null, 2));
    await setupDashboardSettingsForNewlyUser(userSettings);
    swal("Success", "Answers saved!", "success");
    history.push("/dashboard");
  };
  const getUserRole = async () => {
    try {
      setLoading(true);
      let data = await DEATH_API.getUpdatedRole();
      if (data && data.data && data.data.setting) {
        localStorage.setItem("setting", JSON.stringify(data.data.setting));
      }
      setLoading(true);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const currentQuestions = steps[currentStep];
  return (
    <div style={{ position: "relative" }}>
      <div className="stepper-container">
        {/* Stepper Header */}
        <div className="stepper-header">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`step ${
                index === currentStep
                  ? "current-step"
                  : index < currentStep
                  ? "completed-step"
                  : ""
              }`}
            >
              <div className="step-circle">{index + 1}</div>
              <span className="step-title">{step.title}</span>
            </div>
          ))}
        </div>

        <div className="stepper-name">{currentQuestions.title}</div>
        <div className="questions-section">
          {currentQuestions.questions.map((q, index) => (
            <div key={index} className="question-block">
              <div className="question-title">{q.question}</div>
              {q.options.map((option, optIdx) => (
                <label key={optIdx} className="option-label">
                  <input
                    id="check"
                    value={option.value}
                    type={q.select === "multiple" ? "checkbox" : "radio"} // Use checkbox for multiple, radio for single
                    name={
                      q.select === "multiple"
                        ? `check-${index}-${optIdx}`
                        : `question-${index}`
                    }
                    checked={
                      q.select === "multiple"
                        ? (answers &&
                            answers[q.question] &&
                            answers[q.question].includes(option.value)) ||
                          false
                        : answers && answers[q.question] === option.value
                    }
                    onChange={() =>
                      handleOptionChange(
                        currentStep,
                        q.question,
                        option.value,
                        q.select
                      )
                    }
                  />
                  <span class="checkmark-question"></span>
                  {option.value}
                </label>
              ))}
            </div>
          ))}
        </div>

        <div className="stepper-controls">
          <button
            className="question-block-button"
            onClick={handlePrevious}
            disabled={currentStep === 0}
          >
            Previous
          </button>
          {currentStep < steps.length - 1 ? (
            <React.Fragment>
              <button className="question-block-button" onClick={handleNext}>
                Next
              </button>
              <button className="question-block-button" onClick={handleSkip}>
                Skip
              </button>
            </React.Fragment>
          ) : (
            <button className="question-block-button" onClick={handleSave}>
              Save & Finish
            </button>
          )}
        </div>
      </div>
      <NewLoader isLoading={loading} />
    </div>
  );
};
